export default "__VITE_ASSET__874d9a6e__"